<form [formGroup]="filtersForm" novalidate>
    <div class="row">
        <div class="col-md-3">
            <div class="form-group">
                <label>Reservation Type</label>
                <ng-select formControlName="resType" [multiple]="true">
                    <ng-option *ngFor="let contract of contracts" [value]="contract.contractId">
                        {{ contract.contractId }}
                    </ng-option>
                </ng-select>
            </div>
        </div>

        <div class="col-md-3">
            <div class="form-group">
                <label>Reservation Status</label>
                <ng-select formControlName="resStatus" [multiple]="true">
                    <ng-option *ngFor="let status of reservationStatusList" [value]="status.resStatusId">
                        {{ status.resBoText }}
                    </ng-option>
                </ng-select>
            </div>
        </div>

        <div class="col-md-3">
            <div class="form-group">
                <label>Reservation From Date</label>
                <div class="input-group input-group-lg">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <fa-icon [icon]="['far', 'calendar-alt']" class="mx-auto"></fa-icon>
                      </span>
                    </div>
                    <input
                        [bsConfig]="{ containerClass: 'theme-primary', isAnimated: true , customTodayClass:'custom-today-class'}"
                        bsDatepicker
                        formControlName="startDate"
                        class="form-control"
                        placeholder="Select date"
                    >
                </div>
            </div>
        </div>

        <div class="col-md-3">
            <div class="form-group">
                <label> Reservation To Date</label>
                <div class="input-group input-group-lg">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <fa-icon [icon]="['far', 'calendar-alt']" class="mx-auto"></fa-icon>
                      </span>
                    </div>
                    <input
                            [bsConfig]="{ containerClass: 'theme-primary', isAnimated: true, customTodayClass:'custom-today-class'}"
                            bsDatepicker formControlName="endDate" class="form-control" placeholder="Select date">
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <label>Stations</label>
                <ng-select formControlName="stationCodes" [multiple]="true">
                    <ng-option *ngFor="let station of stations" [value]="station.stationid">
                        {{ station.stationid }} - {{ station.airportName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="col-md-3" *ngIf="!disabledFilters.includes('companyName')">
            <div class="form-group">
                <label> Customer Bill To (Company Name)</label>
                <ng-select id="customer" [multiple]="false" formControlName="companyName" placeholder="Select Customer">
                    <ng-option *ngFor="let customer of customerList" [value]="customer.COMPANY_NAME">
                        {{customer.COMPANY_NAME}}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group">
                <label class="form-label" for="isCapitalOne">Promotional Contract</label>
                <ng-select
                        [items]="yesNoOptions"
                        bindLabel="label"
                        bindValue="value"
                        [multiple]="true"
                        formControlName="isCapitalOne"
                >
                </ng-select>
            </div>
        </div>
    </div>

    <div class="row mt-2 mb-4">
        <div class="col-md-2">
            <button type="button" class="btn mt-2 btn-sm btn-block btn-primary btn-square" (click)="onSearch()">Search</button>
        </div>
        <div class="col-md-2">
            <button type="button" class="btn mt-2 btn-sm btn-block btn-primary btn-square" (click)="onClear()">Clear</button>
        </div>
    </div>
</form>
